package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.DeliveryDraft
import com.milta.feature.route.domain.entity.RouteBatchResult
import com.milta.feature.route.domain.repository.RouteRepository

/** POST /api/v1/route-batches (MIL-39). */
class CreateRouteBatchUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(
        driverAccountIds: List<String>,
        deliveries: List<DeliveryDraft>,
        optimize: Boolean,
        date: String? = null,
        // MIL-99 — Enterprise's loading address (start point of every route of the batch).
        loadingAddressId: String? = null,
    ): RouteBatchResult = repository.createRouteBatch(driverAccountIds, deliveries, optimize, date, loadingAddressId)
}
